import React, { useEffect, useState } from 'react';
import apiClient from '../../acciones/apiClient';
import "./series.css";
import { NavBar } from "../../componentes/navbar";
import { Card } from "../../componentes/cards/card";
import { CardTende } from '../../componentes/cardTende/cardtende';
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';
import { useDispatch, useSelector } from 'react-redux';
import { getPopularSeries } from '../../acciones/index';
import { useLocation } from 'react-router-dom';
import AdSenseComponent from '../../componentes/adSense/adSenseComponent';

export const Series = () => {
    const dispatch = useDispatch();
    const [seleccion, setSeleccion] = useState('hoy');
    const [manhwas, setManhwas] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);  // Cambié fetchProyectosPaginated por setCurrentPage
    const [totalPages, setTotalPages] = useState(0);
    const [filterType, setFilterType] = useState('Todos');
    const [sortOrder, setSortOrder] = useState('A - Z');
    const [filterGenre, setFilterGenre] = useState('Genero');


    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const [searchQuery, setSearchQuery] = useState(searchParams.get('search') || '');




    // Función para obtener manhwas
    const fetchManhwas = async (page, type, order, genre, search) => {
        try {
            const queryParam = search ? `&search=${search}` : '';
            const response = await apiClient.get(
                `/proyectos/paginated?page=${page}&limit=16&type=${type}&order=${order}&genre=${genre}${queryParam}`
            );
            setManhwas(response.data.proyectos || []);
            setTotalPages(response.data.totalPages || 0);
        } catch (error) {
            console.error('Error al obtener manhwas paginados:', error);
        }
    };

    // Extrae parámetros de búsqueda desde la URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const search = searchParams.get('search') || '';
        setSearchQuery(search); // Actualiza el estado basado en la URL
    }, [location.search]);

    useEffect(() => {
        if (searchQuery) {
            console.log(`Buscando proyectos para: ${searchQuery}`);
            fetchManhwas(currentPage, filterType, sortOrder, filterGenre, searchQuery); // Modifica tu función para incluir el query
        }

    }, [searchQuery, currentPage, filterType, filterGenre, sortOrder]);


    // Efecto para recargar manhwas al cambiar la búsqueda o filtros
    useEffect(() => {
        fetchManhwas(currentPage, filterType, sortOrder, filterGenre, searchQuery);
    }, [currentPage, filterType, sortOrder, filterGenre, searchQuery]);


    // Función para renderizar la paginación
    const renderPagination = () => (
        <div className="paginacion">
            <ul className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index}>
                        <button
                            onClick={() => setCurrentPage(index + 1)}
                            className={`w-10 h-10 rounded-full font-bold transition ${currentPage === index + 1
                                    ? 'bg-cyan-400 text-white'
                                    : 'bg-white text-cyan-400 hover:bg-cyan-700 hover:text-white'
                                }`}
                        >
                            {index + 1}
                        </button>
                    </li>
                ))}
            </ul>
        </div>

    );

    const popularSeries = useSelector((state) => state.popularSeries);

    useEffect(() => {
        dispatch(getPopularSeries());
    }, [dispatch]);

    const renderTendencias = (series) => {
        return series.map((serie) => (
            <CardTende
                key={serie.proyectoId}
                id={serie.proyectoId}
                cover={serie.portada}
                title={serie.titulo}
            />
        ));
    };

    useEffect(() => {
        console.log(`Buscando: ${searchQuery}`);

        const fetchFilteredManhwas = async () => {
            try {
                const response = await apiClient.get(`/proyectos/paginated?page=${currentPage}&limit=16&search=${searchQuery}`);
                console.log('Proyectos obtenidos:', response.data.proyectos); // Verifica la respuesta del backend
                setManhwas(response.data.proyectos || []); // Actualiza el estado con los proyectos que coinciden con la búsqueda
                setTotalPages(response.data.totalPages || 0);
            } catch (error) {
                console.error('Error al obtener manhwas paginados:', error);
            }
        };

        fetchFilteredManhwas();
    }, [currentPage, searchQuery]); // Asegúrate de incluir `searchQuery` como dependencia


    return (
        <div>
            <ImgCabecera />
            <NavBar />
            <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className="filtersSeries">
                <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                    <option value="Todos">Todos</option>
                    <option value="Manga">Manga</option>
                    <option value="Manhuas">Manhuas</option>
                    <option value="Manhwa">Manhwa</option>
                    <option value="Novela">Novela</option>
                </select>
                <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                    <option value="A - Z">A - Z</option>
                    <option value="Z - A">Z - A</option>
                    <option value="Mas Vistos">Mas Vistos</option>
                    <option value="Ultimos Proyectos">Ultimos Proyectos</option>
                    <option value="Ultimos Capitulos">Ultimos Capitulos</option>
                </select>
                <select value={filterGenre} onChange={(e) => setFilterGenre(e.target.value)}>
                    <option>Genero</option>
                    <option value="+18">+18</option>
                    <option value="Aventura">Aventura</option>
                    <option value="Acción">Acción</option>
                    <option value="Bestias">Bestias</option>
                    <option value="Comedia">Comedia</option>
                    <option value="Demonios">Demonios</option>
                    <option value="Deportes">Deportes</option>
                    <option value="Drama">Drama</option>
                    <option value="Escolares">Escolares</option>
                    <option value="Fantasía">Fantasía</option>
                    <option value="Harem">Harem</option>
                    <option value="Magia">Magia</option>
                    <option value="Misterio">Misterio</option>
                    <option value="Moderno">Moderno</option>
                    <option value="One-shot">One-shot</option>
                    <option value="Psicológicos">Psicológicos</option>
                    <option value="Reencarnación">Reencarnación</option>
                    <option value="Romance">Romance</option>
                    <option value="Transmigración">Transmigración</option>
                    <option value="Tragedia">Tragedia</option>
                    <option value="Thriller">Thriller</option>
                    <option value="Smut">Smut</option>
                    <option value="Slice of Life">Slice of Life</option>
                    <option value="Sobrenatural">Sobrenatural</option>
                    <option value="Vampiros">Vampiros</option>
                    <option value="Venganza">Venganza</option>
                </select>
            </div>


            <div className='contenPT2'>
                <div className="bloqueManhwas">
                    <h1 className="TListaManh">Lista de Manhwas</h1>
                    <div className="proyect12-2">
                        {manhwas.length > 0 ? (
                            manhwas.map((manhwa) => (
                                <Card
                                    key={manhwa.proyecto_id}
                                    id={manhwa.proyecto_id}
                                    cover={manhwa.portada}
                                    title={manhwa.titulo}
                                    author={manhwa.autor}
                                />
                            ))
                        ) : (
                            <p>No se encontraron series que coincidan con tu búsqueda.</p>
                        )}
           
                    </div>
                    {renderPagination()}
                </div>
                


                {/* ------------------------------------------------Tendencias-------------------------------------------------------- */}
                <div className='tende2'>
                    <h1>Tendencias</h1>
                    <div className='pestTende'>
                        <a onClick={() => setSeleccion('hoy')}>Hoy</a>
                        <a onClick={() => setSeleccion('semana')}>Semana</a>
                        <a onClick={() => setSeleccion('todos')}>Todos</a>
                    </div>
                    <div className='contenidoTendencias'>
                        {seleccion === 'hoy' && renderTendencias(popularSeries.hoy || [])}
                        {seleccion === 'semana' && renderTendencias(popularSeries.semana || [])}
                        {seleccion === 'todos' && renderTendencias(popularSeries.todos || [])}
                    </div>
                </div>
            </div>
        </div>
    );
};